import React from 'react';
import classnames from 'classnames';
import { generateSimpleClass } from '../utils';

type screenSizes = Array<import('../types').Layout['screenSizes']>;

export interface RowProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  component?: React.ElementType;
  element?: string;
  start?: screenSizes;
  center?: screenSizes;
  end?: screenSizes;
  middle?: screenSizes;
  bottom?: screenSizes;
  around?: screenSizes;
  between?: screenSizes;
}

const Row: React.FunctionComponent<RowProps> = ({
  className,
  element = 'div',
  component,
  children,
  /* Alignment classes */
  start,
  center,
  end,
  middle,
  bottom,
  /* Distribution classes */
  around,
  between,
  ...otherProps
}) => {
  const Element = component || element;

  /* Alignment classes */
  const startClass = start && generateSimpleClass({ start });
  const centerClass = center && generateSimpleClass({ center });
  const endClass = end && generateSimpleClass({ end });
  const middleClass = middle && generateSimpleClass({ middle });
  const bottomClass = bottom && generateSimpleClass({ bottom });

  /* Distribution classes */
  const aroundClass = around && generateSimpleClass({ around });
  const betweenClass = between && generateSimpleClass({ between });

  return (
    <Element
      className={classnames(
        'row',
        className,
        startClass,
        centerClass,
        endClass,
        middleClass,
        bottomClass,
        aroundClass,
        betweenClass
      )}
      {...otherProps}
    >
      {children}
    </Element>
  );
};

export default Row;
